import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'

interface RtvDetailsParams {
  variant_sku?: string
}

const useGetRtvDetails = (params: RtvDetailsParams = {}) => {
  const Api = useApi()

  const initialFilters = {
    variant_sku: params.variant_sku || '',
    returns_type: 'rtv',  
  }

  const {filters, setSingleFilter} = useFilters(initialFilters)

  const {data: response, isFetching, refetch} = Api.useGetQuery(
    `/analytics/replenishment/zoho/returns/data`,
    {
      queryId: `rtv-details-${params.variant_sku}`,
      filters: filters,
      isToast: false,
    },
    {
      enabled: !!params.variant_sku, // Only fetch when variant_sku is provided
    }
  )

  const fetchRtvDetails = (variantSku: string) => {
    setSingleFilter('variant_sku', variantSku)
    refetch()
  }

  return {
    rtvDetails: response?.data,
    isLoading: isFetching,
    filters,
    fetchRtvDetails,
    refetch,
  }
}

export default useGetRtvDetails
